const bucketbirdBaseUrl = process.env.REACT_APP_B2_BUCKET_URL;

const birdBaseUrl = `${bucketbirdBaseUrl}/bird`;

const PARTNER = process.env.REACT_APP_PARTNER || 'instaview';

const partnerBaseUrl = `${bucketbirdBaseUrl}/${PARTNER}`;

type birdAssetsType = {
  birdNotificationIcon: string;
  birdLibraryIcon: string;
  birdWikiIcon: string;
  birdInfoImage: string;
  birdCalenderIcon: string;
  birdGradientIcon: string;
  birdNotificationImage: string;
  birdLibraryImage: string;
  birdWikiImage: string;
  birdEventsImage: string;
  birdNoPlanIllustration: string;
  crossIcon: string;
  birdPlanActivatedIllustration: string;
  birdCameraIcon: string;
  blackBirdIcon: string;
  blackEvenIcon: string;
  blackLibraryIcon: string;
  blackWikipediaIcon: string;
  CannotDeleteDefaultCardIllustration: string;
  birdDefaultScreenshotImg: string;
};

export const birdAssets: birdAssetsType = {
  birdNotificationIcon: `${birdBaseUrl}/birdIcon.svg`,
  birdLibraryIcon: `${birdBaseUrl}/birdLibraryIcon.svg`,
  birdWikiIcon: `${birdBaseUrl}/wikipediaIcon.svg`,
  birdInfoImage: `${birdBaseUrl}/birdInfo.jpg`,
  birdCalenderIcon: `${birdBaseUrl}/calenderIcon.svg`,
  birdGradientIcon: `${birdBaseUrl}/gradientBirdIcon.svg`,
  birdNotificationImage: `${birdBaseUrl}/birdNotification.jpg`,
  birdLibraryImage: `${birdBaseUrl}/birdSpecies.jpg`,
  birdWikiImage: `${birdBaseUrl}/birdInfo.svg`,
  birdEventsImage: `${birdBaseUrl}/birdCloud.png`,
  birdNoPlanIllustration: `${birdBaseUrl}/noPlanComparision.svg`,
  crossIcon: `${birdBaseUrl}/crossIcon.svg`,
  birdPlanActivatedIllustration: `${birdBaseUrl}/birdPlanActivatedIllustration.svg`,
  birdCameraIcon: `${birdBaseUrl}/crossIcon.svg`,
  blackBirdIcon: `${birdBaseUrl}/blackBirdIcon.svg`,
  blackEvenIcon: `${birdBaseUrl}/blackEventIcon.svg`,
  blackLibraryIcon: `${birdBaseUrl}/blackLibraryIcon.svg`,
  CannotDeleteDefaultCardIllustration: `${partnerBaseUrl}/actionDeclinedOnCard.svg`,
  blackWikipediaIcon: `${bucketbirdBaseUrl}/common/blackWikipediaIcon.svg`,
  birdDefaultScreenshotImg: `${birdBaseUrl}/birdDefaultScreenshotImg.jpg`
};
